import React from "react";
import { useNavigate } from "react-router-dom";
import CatalogueList from "./components/CatalogueList";
import ProductLotCollection from "./components/ProductLotCollection";
import ProductAuctionDetailAndTimeSlot from "./components/ProductAuctionDetailAndTimeSlot";

function SingleProductAuctionDetails() {
    const naviagte = useNavigate();

    return (
        <div>
            <span className="valign-wrapper gap-1">
                <span
                    className={`material-icons pointer`}
                    onClick={() => naviagte("/")}
                >
                    west
                </span>
                <h4>Auction Detail</h4>
            </span>
            <div className={`flex gap-1 column`}>
                <ProductAuctionDetailAndTimeSlot />
                <ProductLotCollection />
                <CatalogueList />
            </div>
        </div>
    );
}

export default SingleProductAuctionDetails;
